import { render, staticRenderFns } from "./CourseCategoryList.vue?vue&type=template&id=42682cab"
import script from "./CourseCategoryList.vue?vue&type=script&lang=js"
export * from "./CourseCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports